import React, { useState } from 'react'

const PublicationCard = (props) => {
  const { title, authors, location, confTitle, abstract, type } = props
  const { pdfLink, dataLink, gitHubLink } = props
  const [showAbstract, setShowAbstract] = useState(false)

  const authorList = Array.isArray(authors) ? authors : [authors]

  return (
    <article className='pub'>
      <div className='pub__meta'>
        {confTitle && <span className='venue-pill'>{confTitle}</span>}
        {type && <span className='pub__type'>{type}</span>}
      </div>
      <h3 className='pub__title'>{title}</h3>
      <p className='pub__authors'>
        {authorList.map((a, i) => (
          <React.Fragment key={a + i}>
            {a}
            {i < authorList.length - 1 && ', '}
          </React.Fragment>
        ))}
      </p>
      {location && <p className='pub__venue'>{location}</p>}

      {(pdfLink || dataLink || gitHubLink || abstract) && (
        <div className='pub__actions'>
          {pdfLink && (
            <a href={pdfLink} target='_blank' rel='noreferrer'>
              <i className='fa-solid fa-file-pdf' /> Paper
            </a>
          )}
          {gitHubLink && (
            <a href={gitHubLink} target='_blank' rel='noreferrer'>
              <i className='fa-brands fa-github' /> Code
            </a>
          )}
          {dataLink && (
            <a href={dataLink} target='_blank' rel='noreferrer'>
              <i className='fa-solid fa-database' /> Data
            </a>
          )}
          {abstract && (
            <button onClick={() => setShowAbstract(!showAbstract)}>
              <i
                className={`fa-solid ${
                  showAbstract ? 'fa-chevron-up' : 'fa-align-left'
                }`}
              />
              {showAbstract ? 'Hide abstract' : 'Abstract'}
            </button>
          )}
        </div>
      )}

      {showAbstract && <p className='pub__abstract'>{abstract}</p>}
    </article>
  )
}

export default PublicationCard
